const getToggledClassName = isToggled => {
  return isToggled
    ? '!text-primary'
    : '!text-common-bright hover:!bg-white hover:text-primary-light';
};

export { getToggledClassName };
